export default {
    props: {
        currentTimeMarkerUpdateInterval: {
            type: Number,
            default: undefined,
            kComposite: 'currentTimeMarker.updateInterval'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/CurrentTimeMarker.js